// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__8y8Ew","skeleton":"Label_skeleton__VLHmk"};